import { ProcedureStatusEnum, SessionStatus } from "../generated/graphql";

export const canRemoveProcedureActivitySession = (
  procedureStatus: ProcedureStatusEnum | null | undefined,
  sessionStatus: SessionStatus | null | undefined
): boolean => procedureStatus === ProcedureStatusEnum.Preparation && sessionStatus === SessionStatus.Planned;
